var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{staticClass:"locale-select",attrs:{"text":_vm.selectedDisplay}},[_vm._l((_vm.locales),function(l){return [_c('b-dropdown-item',{key:l.Code,class:{ 'selected-local': l.Selected },on:{"click":function($event){return _vm.setLocal(l.Code)}}},[_vm._v(" "+_vm._s(l.Display)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }